module.exports = __webpack_public_path__ + "img/businesses-kahon1-min.505095a0.jpg";